import { createRoute } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import {
  Route as pathlessAuthenticatedRoute,
  requireAnyPermission,
} from '../route';
import { AuditReportsPage } from './AuditReportsPage';

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/audit-reports',
  staticData: {
    app: {
      access: {
        permissionsAnyOf: [
          { action: Action.Report, subject: Subject.SalesOrder },
          { action: Action.Report, subject: Subject.SalesOrderDraft },
          { action: Action.Report, subject: Subject.PurchaseOrder },
        ],
      },
    },
  },
  component: AuditReportsPage,
  loader: () => ({
    crumb: 'Audit Reports',
  }),
  beforeLoad: async ({ context }) => {
    await requireAnyPermission({
      context,
      permissions: [
        { action: Action.Report, subject: Subject.SalesOrder },
        { action: Action.Report, subject: Subject.SalesOrderDraft },
        { action: Action.Report, subject: Subject.PurchaseOrder },
      ],
    });
  },
});
